<button class="burger-button" mat-fab type="button" [matMenuTriggerFor]="menu">
	<div class="burger">
		<mat-icon class="burger-button--icon">menu</mat-icon>
	</div>
</button>
<mat-menu class="custom profile" #menu="matMenu">
	<ng-container>
		<div class="burger-menu--header">
			<p class="burger-menu--header-title">
				{{'ME.TITLE' | translate | uppercase}}
			</p>
		</div>
		<div class="burger-menu--body">
			<a class="burger-menu--body-link"
				 routerLink="me/information"
				 [defTrackEvent]="{ category: gaCategory, action:'Navigate to Profil' }">
				<def-side-tabs class="profil" title="{{ 'ME.SIDEMENU.INFORMATION' | translate }}" selectedTab="information" icon="me">
				</def-side-tabs>
			</a>
			<a class="burger-menu--body-link"
				 routerLink="me/formation"
				 [defTrackEvent]="{ category: gaCategory, action:'Navigate to My Course Instances' }">
				<def-side-tabs class="profil" title="{{ 'ME.SIDEMENU.FORMATION' | translate }}" selectedTab="formation" icon="school">
				</def-side-tabs>
			</a>
			<a class="burger-menu--body-link"
				 routerLink="me/reservation"
				 *nbIsGranted="['view', 'booking']"
				 [defTrackEvent]="{ category: gaCategory, action:'Navigate to My Room Bookings' }">
				<def-side-tabs class="profil" title="{{ 'ME.SIDEMENU.RESERVATION' | translate }}" selectedTab="reservation" icon="store">
				</def-side-tabs>
			</a>
			<a class="burger-menu--body-link"
				 href="javascript:Didomi.preferences.show()"
				 [defTrackEvent]="{ category: gaCategory, action:'Manage cookies' }">
				<def-side-tabs class="profil" title="{{ 'ME.SIDEMENU.COOKIES' | translate }}" icon="settings">
				</def-side-tabs>
			</a>
			<a class="burger-menu--body-link" (click)="logout()"
				 [defTrackEvent]="{ category: gaCategory, action:'Log out' }">
				<def-side-tabs class="profil" title="{{ 'ME.SIDEMENU.DECONNEXION' | translate }}" icon="close" last="1">
				</def-side-tabs>
			</a>
		</div>
	</ng-container>
</mat-menu>
